import React, { useContext, useEffect, useState } from 'react';
import { store } from '../store';
import {
  fetchSeasons,
  fetchPlayerStatistics,
  fetchTeamStatistics,
} from '../util/api/requests';
import { Tab, Tabs } from 'react-bootstrap';
import PlayerStatisticsDataTable from '../modules/datatables/PlayerStatisticsDataTable';
import PlayerStatisticsDetailDataTable from '../modules/datatables/PlayerStatisticsDetailDataTable';
import TeamStatisticsDataTable from '../modules/datatables/TeamStatisticsDataTable';
import { renderSpinner } from '../util/util';
import '../style/Tabs.css';

export const Statistics = () => {
  const [seasons, setSeasons] = useState([]);
  const [currentSeason, setCurrentSeason] = useState({});
  const [playerStatistics, setPlayerStatistics] = useState();
  const [teamStatistics, setTeamStatistics] = useState();
  const [currentLeague, setCurrentLeague] = useState();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const [loading, setLoading] = useState({
    playerStatistics: false,
    teamStatistics: false,
    seasons: false,
  });

  useEffect(() => {
    (async () => {
      
      const loadSeasons = async () => {
        if (seasons.length) {
          return seasons;
        }
        
        let loadedSeasons = await fetchSeasons();
        // Sort seasons and leagues
        loadedSeasons.forEach((season) => {
          season.leagues.sort((a, b) => b.name.localeCompare(a.name, 'et'));
        });
        loadedSeasons.sort((a, b) => b.name.localeCompare(a.name, 'et'));
        setSeasons(loadedSeasons);
        return loadedSeasons;
      }
      
      try {
        setLoading((l) => ({ ...l, seasons: true }));
        const seasons = await loadSeasons();

        if (
          globalState.state.selectedSeason &&
          globalState.state.selectedLeague
        ) {
          const updatedCurrentSeason = seasons.find(
            (session) => session.id === globalState.state.selectedSeason.id
          );
          const updatedCurrentLeague = updatedCurrentSeason?.leagues.find(
            (league) => league.id === globalState.state.selectedLeague
          );
          setCurrentSeason(updatedCurrentSeason);
          setCurrentLeague(
            updatedCurrentLeague ? updatedCurrentLeague.id : null
          );
        } else {
          const newCurrentSeason = seasons[0];
          const newCurrentLeague = newCurrentSeason?.leagues.length
            ? newCurrentSeason.leagues[0].id
            : 0;
          setCurrentSeason(newCurrentSeason);
          setCurrentLeague(newCurrentLeague);
        }
      } catch (error) {
        console.error('Error fetching seasons:', error);
      } finally {
        setLoading((l) => ({ ...l, seasons: false }));
      }
    })();
  }, [globalState.state.selectedLeague, globalState.state.selectedSeason]);

  useEffect(() => {
    (async () => {
      if (currentSeason?.id) {
        try {
          setLoading((l) => ({
            ...l,
            playerStatistics: true,
            teamStatistics: true,
          }));

          const [playerStats, teamStats] = await Promise.all([
            fetchPlayerStatistics(currentSeason.id),
            fetchTeamStatistics(currentSeason.id),
          ]);

          setPlayerStatistics(playerStats);
          setTeamStatistics(teamStats);
        } catch (error) {
          console.error('Error fetching statistics:', error);
        } finally {
          setLoading((l) => ({
            ...l,
            playerStatistics: false,
            teamStatistics: false,
          }));
        }
      }
    })();
  }, [currentSeason?.id]);

  const handleSeasonChanged = (e) => {
    setPlayerStatistics(null);
    setTeamStatistics(null);
    const season = seasons.find(
      (session) => session.id === Number(e.target.value)
    );
    setCurrentSeason(season);
    if (season.leagues.length) {
      setCurrentLeague(season.leagues[0].id);
      dispatch({
        type: 'SET_SELECTED_STATE',
        state: { selectedSeason: season, selectedLeague: season.leagues[0].id },
      });
    } else {
      dispatch({
        type: 'SET_SELECTED_STATE',
        state: { selectedSeason: season, selectedLeague: currentLeague },
      });
    }
  };

  const handleLeagueChanged = (e) => {
    dispatch({
      type: 'SET_SELECTED_STATE',
      state: { selectedSeason: currentSeason, selectedLeague: Number(e) },
    });
    setCurrentLeague(Number(e));
  };

  return (
    <div className="statistics_wrapper">
      {seasons && (
        <div id="select_season">
          <select
            className="form-control"
            value={currentSeason ? currentSeason.id : 0}
            onChange={handleSeasonChanged}
          >
            {seasons.map((season) => (
              <option key={season.id} value={season.id}>
                {season.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {loading.seasons && renderSpinner()}

      {(loading.playerStatistics || loading.teamStatistics) && renderSpinner()}
      <div>
        {currentSeason && currentSeason.leagues && (
          <Tabs
            className="nav-tabs statistics-tabs"
            activeKey={currentLeague}
            onSelect={handleLeagueChanged}
            id="statistics-tabs"
          >
            {currentSeason.leagues.map((league) => (
              <Tab key={league.id} eventKey={league.id} title={league.name}>
                {playerStatistics && teamStatistics && (
                  <Tabs
                    className="nav_tabs average-tabs"
                    defaultActiveKey="playerStatisticsGeneral"
                    id="average-tabs"
                  >
                    <Tab
                      key="playerStatisticsGeneral"
                      eventKey="playerStatisticsGeneral"
                      title="Mängijad"
                    >
                      <PlayerStatisticsDataTable
                        playerStatistics={
                          playerStatistics.find(
                            (s) => s.leagueId === currentLeague
                          ).playerStatisticsList
                        }
                        season_id={currentSeason.id}
                        searching={true}
                        sortable={false}
                      />
                    </Tab>
                    <Tab
                      key="playerStatisticsDetail"
                      eventKey="playerStatisticsDetail"
                      title="Mängijad (detailne)"
                    >
                      <PlayerStatisticsDetailDataTable
                        playerStatistics={
                          playerStatistics.find(
                            (s) => s.leagueId === currentLeague
                          ).playerStatisticsList
                        }
                        season_id={currentSeason.id}
                        detailView={true}
                        searching={true}
                        sortable={true}
                      />
                    </Tab>
                    <Tab
                      key="teamStatistics"
                      eventKey="teamStatistics"
                      title="Võistkonnad"
                    >
                      <TeamStatisticsDataTable
                        teamStatistics={
                          teamStatistics.find(
                            (s) => s.leagueId === currentLeague
                          ).roundTeamStatisticsList
                        }
                        season_id={currentSeason.id}
                        searching={true}
                        sortable={true}
                      />
                    </Tab>
                  </Tabs>
                )}
              </Tab>
            ))}
          </Tabs>
        )}
      </div>
    </div>
  );
};
